import { Loader } from 'uikit';

import type { PropsWithChildren, ReactElement } from 'react';
import { useMemo } from 'react';

import { ProjectPageLayout } from '../../Layouts/ProjectPageLayout';

import { ContractStructure } from './ContractStructure';
import type { IContractStructurePageLayout } from './types';

export const ContractStructureLayout = <T,>(
    props: PropsWithChildren<IContractStructurePageLayout<T>>,
): ReactElement<any, any> | null => {
    const { useGetContractStructureDataSource, projectData, methodology } = props;

    const {
        items,
        informers,
        getTagLabel,
        onFiltersUpdated,
        isLoading,
        constructionTypesTabsItems,
        activeConstructionTypeTabItem,
        setActiveConstructionTypeTabItem,
        additionalColumns,
    } =
        useGetContractStructureDataSource?.({
            contractId: projectData?.contractId,
        }) || {};

    const breadCrumbsItems = useMemo(() => {
        const lowerMethodology = methodology?.toLowerCase();

        return [
            {
                label: projectData?.name,
                href: `/projects/${lowerMethodology}/${projectData?.uniqueId}`,
            },
            {
                label: 'Договор',
                href: `/projects/${lowerMethodology}/${projectData?.uniqueId}/contract`,
            },
        ];
    }, [methodology, projectData?.name, projectData?.uniqueId]);

    return (
        <ProjectPageLayout
            title="Структура договора"
            breadCrumbsItems={breadCrumbsItems}
            style={{ height: 'calc(100% - 60px)' }}
        >
            {!projectData || isLoading ? (
                <Loader />
            ) : (
                <>
                    <div className="wrapperToolbarLine withoutPadding" />
                    <ContractStructure
                        informers={informers}
                        items={items}
                        getTagLabel={getTagLabel}
                        onFiltersUpdated={onFiltersUpdated}
                        constructionTypesTabsItems={constructionTypesTabsItems}
                        activeConstructionTypeTabItem={activeConstructionTypeTabItem}
                        setActiveConstructionTypeTabItem={setActiveConstructionTypeTabItem}
                        additionalColumns={additionalColumns}
                    />
                </>
            )}
        </ProjectPageLayout>
    );
};

ContractStructureLayout.displayName = 'ContractStructure';
